/**
 * /reset-password · Public-Form: Email eingeben → /api/auth/reset-request.
 * Backend mailt einen Token-Link, der nach /reset-password/confirm?token=... führt.
 */
import { FormEvent, useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../lib/api';

export function PasswordResetRequest() {
  const [email, setEmail] = useState('');
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function submit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      // Sprint 32 · Pfad-Fix · Backend ist /reset-password-request, nicht /reset-request
      await api('/api/auth/reset-password-request', {
        method: 'POST',
        body: { email },
        skipAuth: true,
      });
      setDone(true);
    } catch (err) {
      // Bewusst keinen verschiedenen Status für 'unknown email' (Info-Disclosure)
      setError((err as { detail?: string }).detail ?? 'Fehler');
    } finally {
      setBusy(false);
    }
  }

  if (done) {
    return (
      <main className="auth-page">
        <div className="auth-card">
          <h1 className="auth-title auth-title--small">CHECK DEINE MAIL</h1>
          <p>
            Wenn ein Konto unter <strong>{email}</strong> existiert, wurde eine Mail mit
            Reset-Link versendet (gültig 24 h).
          </p>
          <Link to="/login" className="auth-submit" style={{ display: 'inline-block' }}>
            ZURÜCK ZUM LOGIN
          </Link>
        </div>
      </main>
    );
  }

  return (
    <main className="auth-page">
      <div className="auth-card">
        <h1 className="auth-title auth-title--small">PASSWORT VERGESSEN</h1>
        <p className="auth-claim">Email eingeben · wir senden dir einen Reset-Link</p>
        <form onSubmit={submit} className="auth-form">
          <div className="auth-field">
            <label className="auth-field__label" htmlFor="r-email">E-MAIL</label>
            <input
              id="r-email"
              type="email"
              className="auth-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoFocus
            />
          </div>
          {error ? <p className="auth-error">{error}</p> : null}
          <button type="submit" className="auth-submit" disabled={busy}>
            {busy ? 'SENDET…' : 'RESET-LINK SENDEN'}
          </button>
          <Link to="/login" className="auth-footer" style={{ textAlign: 'center' }}>
            ← Zurück zum Login
          </Link>
        </form>
      </div>
    </main>
  );
}
